import { render } from "./Rules.vue?vue&type=template&id=0ca36453&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"

import "./Rules.vue?vue&type=style&index=0&id=0ca36453&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ca36453"

export default script